<template>
    <div class="containter" v-loading = 'loading'>
        <div class="topSelect">
            <button class="detailButton" style="margin-right:10px" @click="signEvent">发票标记</button>
            <div class="item">
                <label>记账月份：</label>
                <el-date-picker
                    @change="init(1)"
                    style="width:140px;"
                    v-model="change_month"
                    :clearable='true'
                    type="month"
                    size="mini"
                    value-format="yyyy-MM"
                    placeholder="月份筛选">
                </el-date-picker>
            </div>
            <div class="item">
                <label>消耗月份：</label>
                <el-date-picker
                    @change="init(1)"
                    style="width:140px;"
                    v-model="screenMonth"
                    :clearable='true'
                    type="month"
                    size="mini"
                    value-format="yyyy-MM"
                    placeholder="月份筛选">
                </el-date-picker>
            </div>
            <div class="item">
                <label>签约公司：</label>
                <el-input placeholder="请输入签约公司" style="width:200px" v-model.trim="company" clearable  @keydown.enter.native="company?init(1):''" @clear="init(1)" size="mini">
                    <el-button slot="append" icon="el-icon-search" @click="company?init(1):''" style="padding:0 10px"></el-button>
                </el-input>
            </div>
            <div class="item">
                <label>客户名称：</label>
                <el-input placeholder="请输入客户名称" style="width:200px" v-model.trim="customer_name" clearable  @keydown.enter.native="customer_name?init(1):''" @clear="init(1)" size="mini">
                    <el-button slot="append" icon="el-icon-search" @click="customer_name?init(1):''" style="padding:0 10px"></el-button>
                </el-input>
            </div>
            <div class="item">
                <label>财务审核时间：</label>
                <el-date-picker
                    @change="init(1)"
                    style="width:240px"
                    v-model="approved_date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    size='mini'
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
        </div>
        
        <div>
            <ux-grid
                ref="plxTable"
                :height="height"
                show-footer-overflow="tooltip"
                show-overflow="tooltip"
                :checkboxConfig="{checkMethod: selectable, highlight: true}"
                @selection-change="selectionChange"
                keep-source
                :edit-config="{trigger: 'manual', mode: 'row'}"
                size="mini">
                <ux-table-column type="checkbox" align="center" fixed="left" width="40"/>
                <ux-table-column
                        v-for="item in columns"
                        v-if="!item.manyOrder"
                        :key="item.id"
                        :resizable="true"
                        :field="item.prop"
                        :title="item.label"
                        :width="item.width"
                        :fixed="item.prop=='is_invoiced'?'right':item.prop=='invoiced_time'?'left':item.prop=='applicant'?'':item.fixed"
                        show-header-overflow='tooltip'
                        :edit-render="false"
                        align="center">
                    <template v-slot="{ row }">
                        <div v-if="item.prop == 'files'">
                            <p v-for="(it,ind) in row[item.prop]" :key="ind">{{it}}</p>
                        </div>
                        <div v-else-if="item.prop == 'is_invoiced'">{{row[item.prop]==1?'是':'否'}}</div>
                        <div v-else-if="item.prop == 'invoice_type'">{{row[item.prop]==1?'增值税专用发票':row[item.prop]==2?'增值税普通发票':''}}</div>
                        <span v-else>{{row[item.prop]}}</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="状态" align="center" minWidth="100" field="describe">
                    <template v-slot="{ row }">
                        <span v-if="row.status == 1" style="color:#EF7400">待商务审核</span>
                        <span v-if="row.status == 2" style="color:#3265f3">待财务审核</span>
                        <span v-if="row.status == 3" style="color:#d51313;">商务审核驳回</span>
                        <span v-if="row.status == 4" style="color:#00BB5D;">财务审核通过</span>
                        <span v-if="row.status == 5" style="color:#d51313;">财务审核驳回</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" align="center" minWidth="120" fixed="right" field="describe">
                    <template v-slot="{ row }">
                        <span style="color:#ff9b3c;cursor: pointer;margin-right:5px;" v-if="row.is_invoiced==1" @click="revokeInvoiced(row)">撤销标记</span>
                        <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" @click="goDetail(row)">详情</span>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="paginationBox">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    :page-size="page_size"
                    @current-change="handleCurrentChange"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="" :visible.sync="editFlag" width="1200px" top="10vh" :close-on-click-modal='false'>
            <invoice-detail v-if="editFlag" @cancelToast='cancelToast' @emit_refresh="emit_refresh" :invoice_id='invoice_id'></invoice-detail>
        </el-dialog>
        <el-dialog
            title="发票标记"
            :visible.sync="signFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox" v-loading='loading'>
                <div class="dialogitem">
                    <label style="font-size:14px"><em style="color:red">*</em>开票日期：</label>
                    <el-date-picker
                        style="width:56%"
                        v-model="timeDate"
                        type="date"
                        size="mini"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="signFlag=false" size="mini">取 消</el-button>
                <el-button type="primary" @click="actualInvoiced" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import columnsJson from '../json/invoices_list.js'
import invoiceDetail from './invoiceDetail'
export default {
    components:{
        invoiceDetail
    },
    data(){
        return{
            pickerOptionsMonth:{
                disabledDate(time) {
                    return time.getTime() > new Date('2021-03-31 00:00:00');
                },
            },
            editFlag:false,
            screenMonth:'',
            height:400,
            columns:[],
            page:1,
            page_size:100,
            total:0,
            loading:false,
            invoice_id:'',
            company:'',
            customer_name:'',
            multipleSelection:[],
            multipleSelection1:{},
            selectionList:[],
            flag:false,
            timeDate:'',
            signFlag:false,
            change_month:'',
            approved_date:[]
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.columns = columnsJson
        
        this.init(1)
    },
    mounted(){
        this.height = document.documentElement.clientHeight - 208 > 400 ? document.documentElement.clientHeight - 208 : 400
    },
    methods:{
        signEvent(){
            if(!this.multipleSelection || this.multipleSelection.length == 0){
                this.$message({
                    message: '未选择发票',
                    type: 'warning'
                })
                return
            }
            this.signFlag = true;
        },
        emit_refresh(){//编辑成功
            this.editFlag = false;
            this.init(this.page)
        },
        cancelToast(){
            this.editFlag = false;
        },
        goDetail(data){
            this.invoice_id = data.id;
            this.editFlag=true;
        },
        handleCurrentChange(val){
            this.init(val)
        },
        init(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.customerInvoicesComplement_index,{
               params:{
                   change_month:this.change_month,
                   order_month:this.screenMonth,
                   status: 4,
                   page: page,
                   pagesize: this.page_size,
                   company:this.company,
                   customer_name:this.customer_name,
                   approved_start_date: this.approved_date&&this.approved_date.length>0?this.approved_date[0]:'',
                   approved_end_date: this.approved_date&&this.approved_date.length>0?this.approved_date[1]:'',
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.datas = res.rst.data
                    this.$refs.plxTable.reloadData(this.datas)
                    this.total = res.rst.pageInfo.total;
                    this.$nextTick(()=>{
                        if(this.multipleSelection1['page_'+this.page] && this.multipleSelection1['page_'+this.page].length != 0){
                            var rows = [],arr = []
                            this.multipleSelection1['page_'+this.page].forEach((item)=>{
                                arr.push(item.id)
                            })
                            rows = this.datas.filter((v)=>{
                                return arr.indexOf(v.id) != -1
                            })
                            this.flag =false
                            this.toggleSelection(rows)
                        }else{
                            this.flag = true
                        }
                    })
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        selectable ({row}) {//选择表格限制条件
            return row.is_invoiced != 1
        },
        selectionChange (row) {// 选中的行
          this.selectionList = row
          if(this.flag){
            this.multipleSelection1['page_'+this.page] = this.selectionList;
            this.multipleSelection = [];
            for(var i in this.multipleSelection1){
                this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
            }
          }
        },
        toggleSelection(rows) {
            if (rows) {
            rows.forEach((row,index) => {
                this.$refs.plxTable.toggleRowSelection([
                    {
                        row: row,
                        selected: true
                    }
                ])
                if(index == rows.length-1){
                    this.flag = true
                }
            });
          } 
        },
        actualInvoiced(){
            if(this.timeDate==''){
                this.$message({
                    message: '请选择开票日期',
                    type: 'warning'
                })
                return
            }
            this.loading = true;
            var ids_arr = [];
            this.multipleSelection.forEach((item,index) => {
                ids_arr.push(item.id)
            });
            this.$axios.post(this.URL.BASEURL + this.URL.customerInvoicesComplement_actualInvoiced,{
                ids: ids_arr,
                date: this.timeDate
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.$refs.plxTable.clearSelection();//清空用户选择
                    this.init(this.page)
                    this.signFlag = false
                    this.timeDate = ''
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        revokeInvoiced(data){//撤销标记
            this.$confirm('确定撤销此发票标记？', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                this.$axios.post(this.URL.BASEURL + this.URL.customerInvoicesComplement_delActualInvoiced,{
                    id: data.id,
                }).then((res) => {
                    var res=res.data;
                    this.loading = false;
                    if(res&& res.errno == 0){
                        this.init(this.page)
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                    this.loading = false
                })
            }).catch((action) => {
            });
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../statements/list.scss';
</style>
<style lang="scss">
.topSelect{
    .el-range-editor--mini .el-range-separator{
        width: 20px !important;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/invoice/invoiceCashier.vue